import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
    text: {
        cursor: 'pointer',
    }
}));

const OnMousePopover = ({
    children,
    onClick,
    text,
    textClassName
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        !clicked && setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const [clicked, setClicked] = useState(false);

    const onIconClick = () => {
        onClick ? onClick() : setClicked(!clicked);
    };

    return (
        <div>
            <div
                aria-describedby={open ? 'mouse-over-popover' : undefined}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                className={textClassName ? textClassName : classes.text}
                onClick={onIconClick}
            >
                {text}
            </div>
            <Popover
                id='mouse-over-popover'
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                onClose={handlePopoverClose}
            >
                {children}
            </Popover>
        </div>
    );
};

OnMousePopover.propTypes = {
    text: PropTypes.node,
    textClassName: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func
};

export default OnMousePopover;
